"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TooltippedComponentPropTypes = exports.POSITION = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Portal = _interopRequireDefault(require("../Portal"));
var _styles = require("./styles");
var _events = _interopRequireDefault(require("../utils/events"));
var _utils = require("../utils");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const POSITION = exports.POSITION = {
  BOTTOM: 'bottom',
  HORIZONTAL: 'horizontal',
  LEFT: 'left',
  RIGHT: 'right',
  TOP: 'top',
  VERTICAL: 'vertical'
};
const TooltippedComponentPropTypes = exports.TooltippedComponentPropTypes = {
  target: _propTypes.default.any.isRequired,
  type: _propTypes.default.oneOf(['default', 'error', 'warning', 'info']),
  children: _propTypes.default.any,
  className: _propTypes.default.string,
  tooltipContainerStyles: _propTypes.default.any,
  tooltipInnerStyles: _propTypes.default.any,
  onClick: _propTypes.default.func,
  onMouseEnter: _propTypes.default.func,
  onMouseLeave: _propTypes.default.func,
  tooltip: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),
  tooltipDelay: _propTypes.default.number,
  tooltipHideOnClick: _propTypes.default.bool,
  tooltipPosition: _propTypes.default.oneOf(Object.keys(POSITION).map(key => POSITION[key])),
  tooltipShowOnClick: _propTypes.default.bool
};
class TooltippedComponent extends _react.PureComponent {
  constructor(...args) {
    super(...args);
    this.state = {
      active: false,
      position: this.props.tooltipPosition,
      visible: false
    };
    this.onTransformEnd = e => {
      if (e.propertyName === 'transform') {
        _events.default.removeEventListenerOnTransitionEnded(this.tooltip, this.onTransformEnd);
        this.setState({
          visible: false
        });
      }
    };
    this.handleMouseEnter = event => {
      if (!_utils.isTouchDevice) {
        this.activate(this.calculatePosition(event.currentTarget));
        if (this.props.onMouseEnter) this.props.onMouseEnter(event);
      }
    };
    this.handleMouseLeave = event => {
      this.deactivate();
      if (this.props.onMouseLeave) this.props.onMouseLeave(event);
    };
    this.handleClick = event => {
      if (this.props.tooltipShowOnClick && !this.state.active) {
        this.activate(this.calculatePosition(event.currentTarget));
      }
      if (this.props.tooltipHideOnClick && this.state.active) {
        this.deactivate();
      }
      if (this.props.onClick) this.props.onClick(event);
    };
  }
  componentWillUnmount() {
    if (this.tooltip) {
      _events.default.removeEventListenerOnTransitionEnded(this.tooltip, this.onTransformEnd);
    }
  }
  getPosition(element) {
    const {
      tooltipPosition
    } = this.props;
    if (tooltipPosition === POSITION.HORIZONTAL) {
      const origin = element.getBoundingClientRect();
      const {
        width: ww
      } = (0, _utils.getViewport)();
      const toRight = origin.left < ww / 2 - origin.width / 2;
      return toRight ? POSITION.RIGHT : POSITION.LEFT;
    }
    if (tooltipPosition === POSITION.VERTICAL) {
      const origin = element.getBoundingClientRect();
      const {
        height: wh
      } = (0, _utils.getViewport)();
      const toBottom = origin.top < wh / 2 - origin.height / 2;
      return toBottom ? POSITION.BOTTOM : POSITION.TOP;
    }
    return tooltipPosition;
  }
  calculatePosition(element) {
    const position = this.getPosition(element);
    const {
      top,
      left,
      height,
      width
    } = element.getBoundingClientRect();
    const xOffset = window.scrollX || window.pageXOffset;
    const yOffset = window.scrollY || window.pageYOffset;
    if (position === POSITION.BOTTOM) {
      return {
        top: top + height + yOffset,
        left: left + width / 2 + xOffset,
        position
      };
    }
    if (position === POSITION.TOP) {
      return {
        top: top + yOffset,
        left: left + width / 2 + xOffset,
        position
      };
    }
    if (position === POSITION.LEFT) {
      return {
        top: top + height / 2 + yOffset,
        left: left + xOffset,
        position
      };
    }
    if (position === POSITION.RIGHT) {
      return {
        top: top + height / 2 + yOffset,
        left: left + width + xOffset,
        position
      };
    }
    return {
      top: top + yOffset,
      left: left + width / 2 + xOffset,
      position
    };
  }
  activate({
    top,
    left,
    position
  }) {
    if (this.timeout) clearTimeout(this.timeout);
    this.setState({
      visible: true,
      position
    });
    this.timeout = setTimeout(() => {
      this.setState({
        active: true,
        top,
        left
      });
    }, this.props.tooltipDelay);
  }
  deactivate() {
    if (this.timeout) clearTimeout(this.timeout);
    if (this.state.active) {
      _events.default.addEventListenerOnTransitionEnded(this.tooltip, this.onTransformEnd);
      this.setState({
        active: false
      });
    } else if (this.state.visible) {
      this.setState({
        visible: false
      });
    }
  }
  render() {
    const {
      active,
      left,
      top,
      position,
      visible
    } = this.state;
    const {
      target,
      type,
      children,
      className,
      tooltip,
      tooltipDelay,
      tooltipHideOnClick,
      tooltipPosition,
      tooltipShowOnClick,
      tooltipContainerStyles,
      tooltipInnerStyles,
      ...other
    } = this.props;
    const ComposedComponent = target;
    return _react.default.createElement(ComposedComponent, (0, _extends2.default)({}, other, {
      className: className,
      onClick: this.handleClick,
      onMouseEnter: this.handleMouseEnter,
      onMouseLeave: this.handleMouseLeave
    }), children, visible && _react.default.createElement(_Portal.default, null, _react.default.createElement(_styles.TooltipContainer, {
      active: active,
      position: position,
      ref: node => {
        this.tooltip = node;
      },
      style: {
        top,
        left
      },
      tooltipContainerStyles: tooltipContainerStyles,
      tooltipInnerStyles: tooltipInnerStyles
    }, _react.default.createElement(_styles.TooltipInner, {
      type: type
    }, tooltip))));
  }
}
TooltippedComponent.defaultProps = {
  type: 'default',
  className: '',
  tooltipDelay: 50,
  tooltipHideOnClick: true,
  tooltipPosition: POSITION.VERTICAL,
  tooltipShowOnClick: false
};
var _default = exports.default = TooltippedComponent;